export default (type: any, payload = {}) => {
    return { type, payload };
};

export type Payload = {type: string, payload: any};
